import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { PlayerClass } from '../../classes/player/player.class';
import { Subscription } from 'rxjs';
import { IPlayerData, IPlayerTimetagData } from '../../interfaces/player/player.interface';
import { AlertController, IonIcon, IonRange, IonText, IonButton } from '@ionic/angular/standalone';
import { AlertService } from '../../services/alert/alert.service';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormatHoursTimePipe } from '../../pipes/format-hours-time/format-hours-time.pipe';
import { HttpClient } from '@angular/common/http';
import { IAlertData } from '../../interfaces/utils/utils.interface';
import { FormsModule } from '@angular/forms';
import { addIcons } from 'ionicons';
import { browsers, chevronBack, ellipse, expand, play, pause, playSkipBack, square, stopCircle, arrowRedo, arrowUndo, volumeHigh, volumeLow, volumeMute, contract, recording, helpCircleOutline } from 'ionicons/icons';
import { UtilsAndroidSharedService } from '../../services/utils-android-shared/utils-android-shared.service';
import { ENV_HQSPORT_COMMON } from '@azz-life-streamer/environments';
import { Directory, Filesystem, WriteFileResult } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { Media, MediaAlbum, MediaAlbumResponse, MediaSaveOptions } from '@capacitor-community/media';
import { AlertStatus } from '../../enums/common.enum';
import { MobAlertSharedComponent } from "../mob-alert-shared/mob-alert-shared.component";

@Component({
  selector: 'mob-player-shared',
  standalone: true,
  imports: [IonButton, CommonModule, FormsModule, IonIcon, IonRange, IonText, TranslateModule, MobAlertSharedComponent],
  templateUrl: './mob-player-shared.component.html',
  styleUrl: './mob-player-shared.component.scss',
})

export class MobPlayerSharedComponent extends PlayerClass implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('container', {read: ElementRef}) containerElement!: ElementRef<HTMLDivElement>;
  @ViewChild('videoAzz', {read: ElementRef}) videoElement!: ElementRef;

  @Output() fullscreenClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() exitPage: EventEmitter<boolean> = new EventEmitter<boolean>();

  private _displayMode: 'portrait' | 'landscape' = 'portrait';
  private passwordAlert: HTMLIonAlertElement | undefined;
  private appStateSubscription:  Subscription | undefined = undefined;

  @Input() set mode(value: 'vod' | 'live') {
    this._mode = value;
  }

  @Input() set data(value: IPlayerData) {
    this._data = value;
  }

  @Input() set ready(ready: boolean) {
    console.log('[MobPlayerSharedComponent] set ready: ' + ready);
    this.setReady(ready);
  }

  @Input() set displayMode(mode: 'portrait' | 'landscape') {
    this._displayMode = mode;
    this.screenOrientationChanged(mode);
  }
  @Output() clipCreated: EventEmitter<IPlayerTimetagData> = new EventEmitter<IPlayerTimetagData>();

  get displayMode(): 'portrait' | 'landscape' {
    return this._displayMode;
  }
  constructor(private alertCtrl: AlertController,
              protected alertService: AlertService,
              protected override router: Router,
              protected override translate: TranslateService,
              protected override formatTime: FormatHoursTimePipe,
              @Inject(DOCUMENT) protected override document: any,
              protected override http: HttpClient,
              private utilsAndroidService: UtilsAndroidSharedService,
              //private appService: AppService
            ) {
    super(formatTime, router, translate, document, http);
  }

  // Added HosListeners to capture escape key
  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:onfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])
    fullscreenMode(){
      this.checkFullscreen(document);
    }

  ngOnInit(): void {
    console.log('[MobPlayerSharedComponent] -> On init');
    addIcons({ browsers, chevronBack, contract, ellipse, expand, helpCircleOutline, play, pause, playSkipBack, arrowRedo, square, arrowUndo, volumeHigh, volumeLow, volumeMute, stopCircle });

    // this.appStateSubscription = this.appService.stateChange$.subscribe((isActive: boolean) => {
    //   if (!isActive) {
    //     if (!this.player?.paused) {
    //       this.fullScreenPressed();
    //       this.onPipScreenPressed();
    //     }
    //   } else {
    //     if(this.utilsService.playerPipState) {
    //       this.utilsService.playerPipState = false;
    //     }
    //   }
    // });
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    console.log('[MobPlayerSharedComponent] -> ngAfterViewInit');
    this.init(this.containerElement, this.videoElement);
  }

  ngOnDestroy(): void {
    console.log('[MobPlayerSharedComponent] -> ngOnDestroy');
    this.destroy();
    this.appStateSubscription?.unsubscribe();
    this.passwordAlert?.dismiss()
      .catch(console.error)
  }

  protected override displayAlert(data: IAlertData): void {
    this.alertService.showAlert(data);
  }

  protected override emitExitPage(value: boolean): void {
    this.exitPage.emit(value);
  }

  protected override downloadRecording(): void {
    // https://dev-play.azzulei.tv/<viewerToken>/clip?from=XX&to=YY&id=ZZZ
    const CLIP_URL: string = 'https://' + ENV_HQSPORT_COMMON.playlist + '/' + this._data.token + '/clip?from=' + this.recordingSegmentIndexStart + '&to=' + this.recordingSegmentIndexStop + '&id=' + this.hlsInfo.clientId;

    this.http.get(CLIP_URL, { responseType: 'blob' }).subscribe(async blob => {
      const reader = new FileReader();
  
      reader.onloadend = async () => {
        const base64Data = (reader.result as string).split(',')[1];
  
        const savedFile: WriteFileResult = await Filesystem.writeFile({
          path: 'hqsport-clip.mp4',
          data: base64Data,
          directory: Directory.Cache
        });
  
        //if (this.playerControls.isFullscreen === true) {
        //  this.fullScreenPressed();
        //}

        this.displayAlert({
          show: true,
          status: AlertStatus.question,
          title: 'player.createClipAction',
          text: 'player.createClipWhatToDo',
          closeButton: true,
          buttons: [{
              text: 'player.createClipGallery',
              color: 'primary',
              fill: 'solid',
              closeButton: true,
              handler: (): void => {
                // Save video file in mobile gallery
                this.saveFileToGallery(savedFile);
              }
            },{
              text: 'player.createClipShareFileShort',
              color: 'primary',
              fill: 'solid',
              closeButton: true,
              handler: (): void => {
                this.shareFile(savedFile);
              }
            },
            {
              text: 'general.cancel',
              color: 'primary',
              fill: 'outline',
              closeButton: true,
              handler: (): void => {
              }
            }]
        });
      }
      reader.readAsDataURL(blob);
    });
  }

  protected async saveFileToGallery(file: WriteFileResult){
    console.log('[MobPlayerSharedComponent] saveFileToGallery');
    // Save video file in mobile gallery
    try {
      let error: boolean = true;
      let albums: MediaAlbumResponse = await Media.getAlbums();
      let found: MediaAlbum | undefined = albums.albums.find(element => element.name === 'HQ Sport');
      if (found === undefined) {
        await Media.createAlbum({name: 'HQ Sport'});
        albums = await Media.getAlbums();
        found = albums.albums.find(element => element.name === 'HQ Sport');
      }
      if (found !== undefined){
        await Media.saveVideo({
          path: file.uri,
          albumIdentifier: found.identifier
        });
        error = false;
      }

      if (error === false) {
        this.displayAlertMessage('player.createClipGallerySuccess', true);
      }
      else {
        this.displayAlertMessage('player.createClipGalleryError', false);
      }
      this.recordingStatus = 'stopped';
      this.sendClipCreationToAPI();
    }
    catch (err) {
      this.displayAlertMessage('player.createClipGalleryError', false);
      this.recordingStatus = 'error';
      console.error(err);
    }
  }

  protected displayAlertMessage(msg: string, result: boolean) {
    let msgText: string = msg;
    let status: AlertStatus = result? AlertStatus.success : AlertStatus.error;
    let title: string = result? 'general.done' : 'general.error';

    this.alertService.showAlert({
      show: true,
      status: status,
      title: title,
      text: msgText,
      closeButton: true,
      buttons: [{
        text: 'general.close',
        color: 'primary',
        closeButton: true,
      }]
    });
  }

  protected async shareFile(file: WriteFileResult) {
    console.log('[MobPlayerSharedComponent] shareFile');
    await Share.share({
      title: this.translate.instant('player.createClipShareFile'),
      text: this.translate.instant('player.createClipCheckThisClip'),
      files: [file.uri],
      dialogTitle: this.translate.instant('player.createClipShareWith')
    });
    this.recordingStatus = 'stopped';
    this.sendClipCreationToAPI();
  }

  protected showControls(): void {
    this.mouseIn();
  }

  protected changeVolume(event: any): void {
    this.volumePressed(event, event.detail.value);
  }

  protected override fullScreenPressed(): void {
    // if(this.utilsService.playerPipState) {
    //   this.utilsService.playerPipState = false;
    // }
    super.fullScreenPressed();
    this.fullscreenClicked.emit(this.playerControls.isFullscreen);
  }

  protected override showModal(): void {
    // if (this.displayModalPage === PlayerModals.passwordPrompt) {
    //   this.requestPassword()
    //     .catch(console.error);
    // }
  }

  protected override hideModal(): void {
    if( this.passwordAlert ) {
      this.passwordAlert.dismiss()
        .catch(console.error);
    }
  }

  async requestPassword(): Promise<void> {
    if (this.player) {
      this.destroyPlayer();
      this.player = null;
    }
    this._data.password = '';
    this.passwordAlert = await this.alertCtrl.create({
      header: this.translate.instant('player.protectedPasswordTitle'),
      message: this.translate.instant('player.passwordProtectedMessage'),
      backdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('general.cancel'),
          role: 'cancel',
          handler: () => {
            this.destroyPlayer();
          },
        },
        {
          text: this.translate.instant('general.accept'),
          role: 'enter',
          handler: (event) => {
            this.setPassword(event.password);
          },
        }
      ],
      inputs: [
        {
          name: 'password',
          type: 'password',
          placeholder: 'Password'
        }
      ],
    });

    await this.passwordAlert.present();
  }

  private screenOrientationChanged(displayMode: 'landscape' | 'portrait'): void {
    if(displayMode === 'portrait' && this.playerControls.isFullscreen) {
      this.fullScreenPressed();
    }
    else if(displayMode === 'landscape' && !this.playerControls.isFullscreen) {
      this.fullScreenPressed();
    }
  }

  protected sendClipCreationToAPI() {
    // Trigger event to report this clip to API and DB
    const tagData: IPlayerTimetagData = this.getClipTagData();
    this.clipCreated.emit(tagData);
  }

  protected onPipScreenPressed(): void {
    //this.utilsService.playerPipState = true;
    this.pipScreenPressed();
  }
}